import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { map, Observable } from 'rxjs';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PermissionService } from 'src/app/services/permission.service';
import { PlacesService } from 'src/app/services/places.service';

@Component({
  selector: 'app-user-permission',
  templateUrl: './user-permission.component.html',
  styleUrls: ['./user-permission.component.scss']
})
export class UserPermissionComponent implements OnInit {

  user!: any;
  now: Date = new Date();
  functions: Observable<any> = new Observable();
  placesBusiness: any[] = [];

  openPermission: boolean = true;
  permissionExtra: any[] = [];

  userPermission: Observable<any> = new Observable();
  rolesFunctions: any[] = [];
  companyInfo: Observable<any> = new Observable();
  idPermission: number = 0;
  @Input() infoUserPermission!: any;

  placesUser: any[] = [];
  rolesUser: any[] = [];
  allPlaces: boolean = false;
  profile = this.auth.getProfile();
  rolesProfile: any[] = this.auth.getProfile()?.roles.map((role: any) => role.name);
  superadmin: boolean = this.auth.isSuperAdmin();
  business!: any;
  isOwner: boolean = false;
  admin: boolean = false;
  loaded: boolean = false;
  hasChanges: boolean = false;

  constructor(private auth: AuthenticationService, private placesService: PlacesService, private permissionService: PermissionService,
    private dialog: MatDialog, private location: Location, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.user = this.auth.getProfile();
    this.business = JSON.parse(localStorage.getItem('business') || '{}');

    this.permissionService.getRolesFunctions().subscribe({
      next: (res) => {
        this.rolesFunctions = res.data;
      }
    });

    this.activatedRoute.params.subscribe({
      next: (params) => {
        this.idPermission = +params.idUser;

        this.permissionService.getPermissionUser(this.business?.id, this.idPermission).subscribe({
          next: (res) => {
            this.placesBusiness = res.data.spaces_business || [];
            this.isOwner = this.business.id_user === res.data.user.id;
            this.infoUserPermission = res.data.user;
            this.admin = res.data.roles?.some((role: any) => role.id === 1);
            this.placesUser = res.data.spaces?.map((place: any) => place.id);
            this.rolesUser = res.data.roles?.map((role: any) => role.id);
            this.loaded = true;
          }
        });
      }
    });

    this.permissionExtra = []
  }

  changeFunction(role: any, checked: any) {
    this.rolesUser = this.rolesUser.filter((data) => data !== role);
    if (checked) {
      this.rolesUser.push(role);
    }
    this.hasChanges = true;
  }

  changePlace(place: any, checked: any) {
    this.placesUser = this.placesUser.filter((data) => data !== place);
    if (checked) {
      this.placesUser.push(place);
    }
    this.hasChanges = true;
  }

  goBack() {
    this.location.back();
  }

  savePermission() {
    const payload = {
      spaces: this.placesUser,
      roles: this.rolesUser,
    };
    this.permissionService.savePermissionUser(this.business.id, this.infoUserPermission?.id, payload).subscribe({
      next: (res) => {
        this.openInfoCard('Usuario guardado correctamente');
      }
    });
    this.hasChanges = false;
  }

  openInfoCard(msg: string, disabledClose: boolean = false, close: boolean = false) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        text: msg
      }
    });
    if (close) {
      dialogRef.afterClosed().subscribe({
        next: (val) => this.goBack()
      });
    }
  }

  deleteGestor() {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: {
        icon: true,
        text: '¿Estás seguro de que quieres eliminar al usuario de la empresa?', 
        btnCancel: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.permissionService.deleteUsersPermissionDetail(this.business.id, this.idPermission).subscribe({
          next: (res) => {
            if (res) {
              this.openInfoCard('El usuario ha sido eliminado correctamente', true, true);
            }
          },
          error: (err) => {
            this.openInfoCard('Error al eliminar el usuario');
          }
        });
      }
    })
  }

  private roleDescriptions: { [key: string]: string } = {
    'admin': 'Control total de la empresa: eventos, informes, pedidos, suscriptores y espacios.',
    'superadmin': 'Control global de la plataforma y gestión de todas las empresas.',
    'CREATE_EVENTS': 'Crear y gestionar eventos, bonos e informes.',
    'Gestor de eventos': 'Crear y gestionar eventos, bonos e informes.',
    'ACCESS_REPORTS': 'Ver informes y pedidos con datos económicos.',
    'Finanzas': 'Ver informes y pedidos con datos económicos.',
    'ACCESS_SALES': 'Acceso a taquilla, gestión de pedidos y consulta de informes.',
    'Ventas': 'Acceso a taquilla, gestión de pedidos y consulta de informes.',
    'ACCESS_MARKETING': 'Gestionar suscriptores y herramientas de comunicación.',
    'Marketing': 'Gestionar suscriptores y herramientas de comunicación.',
    'ACCESS_SUPPORT': 'Atención al cliente: suscriptores y pedidos.',
    'Soporte': 'Atención al cliente: suscriptores y pedidos.',
    'ACCESS_QR_APP': 'Validación de entradas mediante la app QRLok.',
    'QR APP': 'Validación de entradas mediante la app QRLok.',
    'ACCESS_CLOUD': 'Acceso completo al panel de la empresa.',
    'ACCOUNT_OWNER': 'Propietario de la cuenta con acceso total.',
    'ACCESS_EXTERN_EVENTS': 'Acceso a eventos externos y gestión de la organización.',
    'ACCESS_ADMIN': 'Administración avanzada: eventos, informes, pedidos y espacios.',
    'Administración': 'Control total de la empresa: eventos, informes, pedidos, suscriptores y espacios.',
    'ACCESS_MANAGER': 'Acceso a configuración básica y perfil.',
  };

  getRoleDescription(roleName: string): string {
    return this.roleDescriptions[roleName] ?? this.roleDescriptions[roleName?.toLowerCase()] ?? '';
  }

}
